import { TFunction } from 'next-i18next'
import { ConvergenceTFunction } from '../../model'

export const defaultError = (t: TFunction | ConvergenceTFunction, name: string): string => t(`paymentMethod:errors.default.${name}`)
